import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Injectable({providedIn: 'root'})
export class TranslationLoaderService {

  constructor(private translate: TranslateService) {
  }

  loadTranslations(): Promise<void> {
    return new Promise((resolve) => {
      this.translate.use('en').subscribe(() => {
        resolve();
      });
    });
  }

}
